import { THEME_STORAGE_KEY, applyTheme, resolveTheme } from '@cirqll/storybook/theme';

/**
 * Replaces the old `useDark()`. Only this module drives the theme, which also fixes the stored-'auto'
 * bug: vueuse wrote 'auto' whenever the chosen mode matched the OS, so the pre-paint check missed and
 * the page flashed light, and the OS could override an explicit choice mid-session.
 */
const stored = useLocalStorage<string>(THEME_STORAGE_KEY, 'light');

export const theme = computed(() => resolveTheme(stored.value));

export function setTheme(value?: string | null) {
    stored.value = resolveTheme(value).name;
}

watch(theme, (current) => {
    applyTheme(current.name);
    void syncStatusBar();
}, { immediate: true });

/**
 * Native only, and loaded on demand so the browser build doesn't pull in the plugin. The TopBar is
 * `bg-primary` in every theme, so the style follows the theme's own `statusBar`, not its scheme.
 */
async function syncStatusBar() {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor.isNativePlatform()) return;

    try {
        const { StatusBar, Style } = await import('@capacitor/status-bar');
        const { statusBar, themeColor } = theme.value.meta;
        await StatusBar.setStyle({ style: statusBar === 'dark' ? Style.Dark : Style.Light });
        if (Capacitor.getPlatform() === 'android') {
            await StatusBar.setBackgroundColor({ color: themeColor });
        }
    } catch {
        // The plugin is optional at runtime; a missing status bar must never break boot.
    }
}
